import React, { useContext } from "react";
import { LegacyCard as Card, Text, Link, InlineStack, DataTable } from "@shopify/polaris";
import constant from "lib/constant/constant";
import { PrivateContext } from "lib/context";
import { fulfillmentsProp } from "app/orders/modules/admin/features/view/propsType";

const Fulfillments = (props) => {
  const { cms } = useContext(PrivateContext);

  const { lineData } = props;
  let row = [];
  let totalQuantity;
  let fulfilledQuantity;
  if (lineData) {
    row = lineData
      .filter((value) => {
        if (value.fulfillmentStatus === constant.FULFILLED) {
          return value;
        }
        return null;
      })
      .map((value) => {
        return [
          <div className="ellipsis">
            <Link url="">{value.name}</Link>
            <Text variant="bodySm" as="p">
              <br />
              <Text as="span">
                {`${cms("label.vendor")}: `}
                <Link>{value.vendor}</Link>
              </Text>
            </Text>
          </div>,
          <Text as="span">{value.trackingCompany}</Text>,
          <Text as="span">{value.trackingNumber}</Text>,
        ];
      });
    totalQuantity = lineData.length;
    fulfilledQuantity = row.length;
  }

  return (
    <Card>
      <Card.Section subdued>
        <DataTable
          columnContentTypes={["text", "text", "numeric"]}
          headings={[cms("label.product"), cms("label.shippingCompany"), cms("label.trackingNumber")]}
          rows={row}
        />
      </Card.Section>
      <Card.Section>
        <InlineStack>
          <Text as="span" fontWeight="semibold">
            {cms("label.totalFulfillments")}
          </Text>
          <Text as="span" fontWeight="semibold">{`${fulfilledQuantity} of ${totalQuantity}`}</Text>
        </InlineStack>
      </Card.Section>
    </Card>
  );
};
Fulfillments.propTypes = fulfillmentsProp.type;
export default Fulfillments;
